var $ad0d0cc7ce385ded$exports = {};
$ad0d0cc7ce385ded$exports = {
    "valid": `Ge\xe7erli`
};


export {$ad0d0cc7ce385ded$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
